export const ENUM_PLAN_TYPE = {
  PAY_AS_GO: "PAY_AS_GO",
  FIXED: "FIXED",
  TRIAL: "TRIAL",
};
